import * as React from 'react';
import logoImg from './chi-logo.png';
import './Logo.scss';

export const Logo = () => (
    <div className="navbar-brand col-sm-3 col-md-2">
        <a href="#">
            <span className="brand-tile">
                <img aria-label="site-logo" src={logoImg} />
            </span>
            <span className="brand-name" aria-label="site-title">Enterprise</span>
            <span className="brand-version" aria-label="site-version">V2</span>
        </a>
    </div>
);
